export default {
	define: {
		"timeout": 30000,
		"env": "dev",
		"isMock": true,
  	"BASE_URL": "https://yue.reactmobile.cn",
	}
}